import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Dialog, DialogContent, DialogActions } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Footer from '../cards/Footer';
import { getMarkDown } from '../utils';
import '../../../stylesheets/triagebot/Dialog.scss';

const EVisitChangeOverDialog = ({
    message,
    open,
    onCancel,
    onAgree,
    isSubmitting,
    setshowCommonReasonEVisitChangeOverDialog,
    showCommonReasonEVisitChangeOverDialog,
    setIsTriageOver,
    selectedSymptom
}) => {
    const dialogHeaderRef = useRef(null);
    const scrollableBoxRef = useRef(null);
    const [eVisitButtonDisable, setEVisitButtonDisable] = useState(true);

    const isOpen = typeof open === 'boolean' ? open : !!showCommonReasonEVisitChangeOverDialog;

    const textA = (message?.data[1]?.changeoverPrompt?.data[1]?.eVisitTosPopup[0]?.definition?.header)
        ? message?.data[1]?.changeoverPrompt?.data[1]?.eVisitTosPopup[0]?.definition?.header
        : '';

    const textF = (message?.data[1]?.changeoverPrompt?.data[1]?.evisitInfo?.textF)
        ? message?.data[1]?.changeoverPrompt?.data[1]?.evisitInfo?.textF.toString().replace(/[**]/g, '')
        : '';

    const textG = (message?.data[1]?.changeoverPrompt?.data[1]?.evisitInfo?.textG)
        ? message?.data[1]?.changeoverPrompt?.data[1]?.evisitInfo?.textG
        : '';

    const textC = (message?.data[1]?.changeoverPrompt?.data[1]?.evisitTos?.textC)
        ? message?.data[1]?.changeoverPrompt?.data[1]?.evisitTos?.textC
        : '';

    const textB = (message?.data[1]?.changeoverPrompt?.data[1]?.evisitTos?.textB)
        ? message?.data[1]?.changeoverPrompt?.data[1]?.evisitTos?.textB
        : '';

    const textD = (message?.data[1]?.changeoverPrompt?.data[1]?.evisitTos?.textD)
        ? message?.data[1]?.changeoverPrompt?.data[1]?.evisitTos?.textD
        : '';

    const continueButtonText = message?.data?.[1]?.changeoverPrompt?.data?.[0]?.nextButton?.displayText || 'Continue to E-Visit';
    const cancelButtonText = message?.data?.[1]?.changeoverPrompt?.data?.[0]?.cancelButton?.displayText || 'Cancel';
    const eVisitdialogHeader = textF.replace('${symptom}', selectedSymptom)

    const language = (message?.data[1]?.changeoverPrompt?.language)
        ? message?.data[1]?.changeoverPrompt?.language
        : '';
        
    const isSpanishLanguage = language.toLowerCase() === 'spanish';
    const handleScrollableBoxScroll = useCallback(() => {
        const scrollableBox = scrollableBoxRef.current;

        if (!scrollableBox) return;

        const scrollBuffer = 2;
        const needsScroll = scrollableBox.scrollHeight > scrollableBox.clientHeight + scrollBuffer;
        const isScrolledToBottom = scrollableBox.scrollTop + scrollableBox.clientHeight >= scrollableBox.scrollHeight - scrollBuffer;

        setEVisitButtonDisable(needsScroll && !isScrolledToBottom);
    }, []);

    const handleAgree = () => {
        if (isSubmitting || eVisitButtonDisable) return;
        if (typeof onAgree === 'function') onAgree();
    }

    const handleButtonEffect = () => {
        if (isSubmitting) return;
        if (typeof onCancel === 'function') {
            onCancel();
        } else {
            if (setshowCommonReasonEVisitChangeOverDialog instanceof Function) {
                setshowCommonReasonEVisitChangeOverDialog(false);
            }
            if (setIsTriageOver instanceof Function) {
                setIsTriageOver(true);
            }
        }
    }

    useEffect(() => {
        if (isOpen) {
            // Move screen reader focus to the dialog header when it opens.
            setTimeout(() => {
                dialogHeaderRef.current?.focus();
            }, 0);
        }
    }, [isOpen]);

    useEffect(() => {
        if (!isOpen) {
            setEVisitButtonDisable(true);
            return;
        }

        setEVisitButtonDisable(true);
        const scrollCheckTimeout = setTimeout(handleScrollableBoxScroll, 0);

        return () => clearTimeout(scrollCheckTimeout);
    }, [handleScrollableBoxScroll, isOpen, textA, textB, textC, textD]);

    // useEffect(() => {
    //     const element = document.getElementsByClassName('loader');
    //     if (element && element?.length > 0) {
    //         element[0].style.visibility = "hidden"; // Set visibility to hidden
    //     }
    // }, [])


    return (
        <>
            <Dialog
                id='change-dialog'
                open={isOpen}
                PaperProps={{
                    className: `Evisit-dialog Changeover-dialog${isSpanishLanguage ? ' spanish-language' : ''}`
                }}
            >
                <div id="dialog-title" className='changeOver-Header'>
                    <b
                        className='headerTextCommon'
                        ref={dialogHeaderRef}
                        tabIndex='-1'
                    >
                        {eVisitdialogHeader}
                    </b>
                </div>
                <DialogContent>
                    <div className='changeOver-PopupBody' tabIndex='0'>
                        <div className='ContentStyle'>
                            <div style={{ fontSize: '18px' }}>{getMarkDown(textG)}</div>
                            <div
                                className='ScrollableBox'
                                ref={scrollableBoxRef}
                                onScroll={handleScrollableBoxScroll}
                            >
                                <div className='changeover-tos-header'>{getMarkDown(textA)}</div>
                                {getMarkDown(textC)}
                                {getMarkDown(textB)}
                                {getMarkDown(textD)}
                            </div>
                        </div>
                    </div>
                </DialogContent>

                <DialogActions id="dialog-footer" style={{ paddingRight: '24px' }}>
                    <Footer>
                        <button
                            className='button-item-cancel'
                            onClick={handleButtonEffect}
                            disabled={isSubmitting}
                        >
                            <span style={{ color: 'inherit', marginRight: '8px' }}>✕</span>
                            {cancelButtonText}
                        </button>
                        <button
                            className={`button-item evisit-dialog-continue-btn ${(isSubmitting || eVisitButtonDisable) ? "disabled" : ""}`}
                            onClick={handleAgree}
                            disabled={isSubmitting  || eVisitButtonDisable}
                        >
                            {continueButtonText}
                            <ArrowForwardIcon className='evisit-dialog-continue-btn__icon' />
                        </button>
                    </Footer>
                </DialogActions>
            </Dialog>
            {isSubmitting && (
                <div style={{position: 'fixed',display: 'flex',top: "50%",left: " 50%",zIndex: 9999,transform: 'translate(-50px, -50px)'}}>
                    <svg className='spinner' width='65px' height='65px' viewBox='0 0 66 66' xmlns='http://www.w3.org/2000/svg'>
                        <circle className='path' fill='none' strokeWidth='6' strokeLinecap='round' cx='33' cy='33' r='30'></circle>
                    </svg>
                </div>
            )}</>

    )
}

export default EVisitChangeOverDialog;